import Header from 'layout/header'
import Main from 'layout/main'
import './styles/main.scss'
import 'styles/app.scss'

const App = () => {
  return (
    <div className='app'>
      <Header />
      <Main />
    </div>
  )
}

export default App
